import {AfterViewInit, ChangeDetectorRef, Directive, ElementRef, Input, OnDestroy} from '@angular/core';
import {FormService} from '../../core/services/form.service';
import {AbstractControl} from '@angular/forms';
import {environment} from '../../../environments/environment';

// TODO: consider deleting
@Directive({
    selector: '[formControlName]',
})
export class ServerValidationOnBlurDirective implements AfterViewInit, OnDestroy {
    @Input() formControlName;

    constructor(
        private elRef: ElementRef,
        private formService: FormService,
        private cd: ChangeDetectorRef
    ) {}

    private initialValue;

    private blurListener = () => {
        if (this.initialValue !== this.control.value) {
            // TODO: uncomment when tooltip errors component is ready
            // this.formService.markFieldAsValid(this.formControlName);
            this.cd.markForCheck();
        }
    };

    private focusListener = () => {
        this.initialValue = this.control.value;
    };

    get control(): AbstractControl {
        return this.formService.getControl(this.formControlName);
    }

    get nativeElement(): HTMLElement {
        return this.elRef.nativeElement;
    }

    ngAfterViewInit() {
        if (!this.control && !environment.production) {
            console.warn(
                `[ServerValidationOnBlurDirective] FormService has not been initialized
                            Do use formService.init(form) on ngOnInit life-cycle hook`
            );
            return;
        }
        if (!this.control) {
            return;
        }
        this.nativeElement.addEventListener('focus', this.focusListener, true);
        this.nativeElement.addEventListener('blur', this.blurListener, true);
    }

    ngOnDestroy() {
        this.nativeElement.removeEventListener('focus', this.focusListener, true);
        this.nativeElement.removeEventListener('blur', this.blurListener, true);
    }
}
